<div class="content" *ngIf="!refresh">
    <div class="top">
        <div class="image-container">
            <app-employee-image *ngIf="user$" class="profile-pic" [employeeId]="user$.userId" round="true" width="200" height="200"></app-employee-image>
            <button 
                mat-mini-fab 
                color="primary" 
                setColor
                [setColorRules]="[
                {
                    color: 'primaryColour',
                    style: 'background'
                }
                ]" 
                class="edit-button"
                type="button"
                [attr.aria-label]="'EditProfilePhoto' | translate: {Default: 'Edit profile photo'}"
                appPreventDoubleClick (throttledClick)="openFormDialog()">
                <mat-icon class="material-icons-outlined" aria-hidden="true">edit</mat-icon>
            </button>
        </div>
    </div>
</div>